<template>
  <div class="cards">
    <empty-card-icon />
    <p class="text-gray-500">You have not added a payment card yet.</p>
    <button
      @click="$emit('addCardModal')"
      class="flex gap-2 font-semibold text-primary-yellow cursor-pointer"
    >
      <span><img src="@/assets/images/icons/add.svg"/></span>
      <span>Add Card</span></button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.cards {
  background: #ffffff;
  box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  height: 40vh;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
</style>
